import * as React from 'react';
export const Icon = ({ icon }) => {
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: icon }, "data-tracking-exclude": true });
};
